@if (supplierId) {
  <app-admin-edit-supplier-component [supplierId]="+supplierId" />
}
